// extracted by mini-css-extract-plugin
export default {"header":"components_header__UEc6A","main":"components_main__x7t2N"};